import React  from 'react'
import DropDown from '../dropdown';
import {Hotels} from '../../../api/services/next'
import { useMemo } from 'react';

const HotelsDropDown = ({...rest}) => {
    const spec = useMemo(() => ({
            IsActive: true,
            IncludeOnlyHotelsWithUserPermissions: true,
        }), [] )

    return <DropDown api={Hotels.GetHotels} spec={spec} textField="Name" valueField="Id"  {...rest}/>
}

export default HotelsDropDown

